import React from 'react';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';
import { DropdownComponent } from '../../../../../components/prime-formik';

const SuperProfileRequiredMinimumEducationInput = () => {
  const { handleChange } = useFormikContext();

  const requiredMinimumEducationOptions = [
    { label: 'None', value: 'NONE' },
    { label: 'High school', value: 'HIGH_SCHOOL' },
    { label: 'Vocational or Technical education', value: 'VOCATIONAL_OR_TECHNICAL_EDUCATION' },
    { label: 'Bachelor', value: 'BACHELOR' },
    { label: 'Master', value: 'MASTER' },
    { label: 'PhD', value: 'PHD' },
    { label: 'Other', value: 'OTHER' },
  ];

  return (
    <div className="p-col-12">
      <div className="flex-space-between">
        <FormattedMessage
          id="account.super-profiles.new.required-minimum-education"
          defaultMessage="Required minimum education"
        >
          {(text) => (
            <label className="field-label" htmlFor="requiredMinimumEducation">
              {text}
            </label>
          )}
        </FormattedMessage>
        <FormattedMessage id="select" defaultMessage="Select">
          {(text) => (
            <Field
              id="requiredMinimumEducation"
              name="requiredMinimumEducation"
              component={DropdownComponent}
              options={requiredMinimumEducationOptions}
              filter
              filterBy="label,value"
              className="right"
              onChange={handleChange}
              placeholder={`-- ${text} --`}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
};

export default SuperProfileRequiredMinimumEducationInput;
